<template>
  <div v-if="dataNotNull" key="1" class="equipmentDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 25px;height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_pro_equipment">List of Activities on site</div>
    <div class="zero_pro_equipment">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "equipment",
  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "equipment",
      dataNotNull: true,
      proj_dict: {
        "1404": "P00056",
        "1002": "P00034",
        "212": "P00005",
        "249": "P00018"
      }
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = []
      var equipments = []
      var assists = []
      var totle = []
      var total = 0
      var assist = 0

      for (var i in result) {
        var type = result[i].type_name
        var count = result[i].count
        legends.push(type.substring(0, 18))
        equipments.push({name: type.substring(0, 18), value: count})
        total += parseInt(count)
      }
      total *= 1.2
      assist = total / 8
      for (var i in result) {
        var type = result[i].type_name
        var count = parseInt(result[i].count) + assist
        assists.push({name: type.substring(0, 18), value: count})
        totle.push({name: type.substring(0, 18), value: total})
      }
      return {legends: legends, equipments: equipments, assists: assists, totle: totle, assist: assist}
    },
    analysisResult2(result2) {
      var legends2 = []
      var equipments2 = []
      var assists2 = []
      var totle2 = []
      var total2 = 0
      var assist2 = 0

      for (var i in result2) {
        var type = result2[i].type_name
        var count = result2[i].count
        legends2.push(type.substring(0, 18))
        equipments2.push({name: type.substring(0, 18), value: count})
        total2 += parseInt(count)
      }
      total2 *= 1.2
      assist2 = total2 / 8
      for (var i in result2) {
        var type = result2[i].type_name
        var count = parseInt(result2[i].count) + assist2
        assists2.push({name: type.substring(0, 18), value: count})
        totle2.push({name: type.substring(0, 18), value: total2})
      }
      return {
        legends2: legends2,
        equipments2: equipments2,
        assists2: assists2,
        totle2: totle2,
        assist2: assist2
      }
    },
    analysisResult3(data3) {
      var legends = []
      var ptwclassifys = []
      var assists3 = []
      var totle3 = []
      var total3 = 0
      var assist3 = 0


      if (data3.length >= 7) {
        //按照count降序
        data3.sort(function (a, b) {
          return b.value - a.value
        })

        //data3，第一部分7个元素，第二部分为剩下的元素作为Others
        var shows = data3.slice(0, 7)
        var others = data3.slice(7)
        var other = 0
        for (var i in shows) {
          var name = shows[i].name
          //
          var value = data3[i].value
          total3 += parseInt(value)
          //
          //如果第一部分本身包含了'other'或类似的type，则将其与第二部分的第一个进行交换，其本身被添加至第二部分的尾部，other作为交换数目的标识
          if (name.toLowerCase() == 'other') {
            other += parseInt('1')
            others.push(shows[i])
          } else {
            legends.push(name)
            ptwclassifys.push({name: name, value: shows[i].value})
          }
        }
        total3 *= 1.2
        assist3 = total3 / 5
        for (var i in shows) {
          var value = parseInt(shows[i].value) + assist3
          assists3.push({name: name, value: value})
          totle3.push({name: name, value: total3})
        }
        //从第二部分取出other个元素，完成交换
        var replace = others.splice(0, other)
        for (var i in replace) {
          legends.push(replace[i].name)
          ptwclassifys.push({name: replace[i].name, value: replace[i].value})
        }
      } else {
        for (var i in data3) {
          var name = data3[i].name
          var value = data3[i].value
          legends.push(name.substring(0, 18))
          ptwclassifys.push({name: name.substring(0, 18), value: value})
          total3 += parseInt(value)
        }
        total3 *= 1.2
        assist3 = total3 / 5
        for (var i in data3) {
          var name = data3[i].name
          var value = parseInt(data3[i].value) + assist3
          assists3.push({name: name.substring(0, 18), value: value})
          totle3.push({name: name.substring(0, 18), value: total3})
        }

      }
      if (data3.length <= 4) {
        var gridh = 100
      } else {
        var gridh = 130
      }

      return {
        legends: legends,
        ptwclassifys: ptwclassifys,
        assists3: assists3,
        totle3: totle3,
        assist3: assist3,
        gridh: gridh
      }
    },
    //获取当前日期，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "212"
    }
    this.myChart = echarts.init(document.querySelector('.equipmentDiv .container1'))
    this.myChart.setOption({
      title: {
        text: 'List of Activities on site ',
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: function (params) {
          return params[1].name + ':  ' + Math.round(params[2].value * 120 / params[0].value) + '%';
        }
      },
      // grid: {
      //   left: 90,
      //   height:130
      // },
      xAxis: {
        type: 'value',
        show: false,
        axisLabel: {
          formatter: '{value}'
        }
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 15,
          align: 'right',
          show: true,
          textStyle: {
            color: '#FFF',
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: false,
              color: '#6cf',
              position: 'insideRight',
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
              borderColor: '#999',
              borderWidth: '0',
            }
          },
          data: []
        },
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: true,
              color: '#6cf',
              position: 'insideRight',
              formatter: '{c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
            }
          },
          data: []
        },
        {
          name: '申请',
          type: 'bar',
          barWidth: '60%',
          data: [],
          label: {
            normal: {
              show: false,
              formatter: '{b}'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      proj_id: this.my_project_id,
      start_date: this.getNowFormatDate(),
      end_date: this.getNowFormatDate(),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjIns", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var legends = []
        var equipments = []
        var result = resp.data.result;
        var data = this.analysisResult(result)
        //第二个接口开始

        let postData2 = {
          proj_id: this.proj_dict[this.my_project_id],
          start_date: this.getNowFormatDate(),
          end_date: this.getNowFormatDate()
        }
        axios.post(this.$store.getters.getDevServer + "DBProjDefect", postData2).then(resp => {
          var errNo2 = resp.data.errno
          var errStr2 = resp.data.errstr_cn
          this.myChart.hideLoading()
          if (errNo2 == "0") {
            this.dataNotNull = true
            var legends2 = []
            var equipments2 = []
            var result2 = resp.data.result;
            // var result2 = [{type_name: "Raised", count: "311"},
            //                 {type_name: "In Progress", count: "160"},
            //                 {type_name: "Raised1", count: "119"},
            //                 {type_name: "In Progress1", count: "216"},
            //   {type_name: "Raised2", count: "110"},
            //   {type_name: "In Progress2", count: "260"}
            //                 ]
            var data2 = this.analysisResult2(result2)
            var ab = data2.equipments2
            var ac = data.equipments
            var data3 = ab.concat(ac)
            //
            var data4 = this.analysisResult3(data3)
            //第二个接口结束
            this.myChart.setOption({
              grid: {
                left: 90,
                height: data4.gridh
              },
              yAxis: {
                data: data4.legends,
              },
              series: [
                {
                  data: data4.totle3
                },
                {
                  data: data4.assists3,
                  label: {
                    normal: {
                      show: true,
                      color: '#6cf',
                      position: 'insideRight',
                      formatter: function (params) {
                        return parseInt(params.value) - parseInt(data4.assist3);
                      }
                    }
                  },
                },
                {
                  data: data4.ptwclassifys
                }
              ]
            })
          } else {
            this.dataNotNull = false
          }

        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
  }
}
</script>

<style lang="stylus" scoped>
.title_pro_equipment
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_pro_equipment
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/quality/equipment.vue